// Modal Content, This content is mainly used for Modal wrap with MainModal.tsx Component
import React from "react";
import SearchBar from "./SearchBar";
import { FaPlay, FaPlus } from "react-icons/fa6";
import user from "../assets/images/user.png";
import { HiOutlineDotsHorizontal } from 'react-icons/hi';
import { TranslateIcon } from "../assets/icons/Icons";

const Voice = () => {
  return (
    <div className="flex gap-3 px-3 py-2 rounded-xl bg-white mb-2">
      <div className="w-10 h-10 rounded-full mt-1 text-white bg-[#2A2A36] flex items-center justify-center">
        <FaPlay className="text-xs" />
      </div>
      <div className="flex-1">
        <div className="flex items-center justify-between">
          <p className="text-[#0F0C18] text-base font-medium tracking-tight">Andrew’s voice 1</p>
          <HiOutlineDotsHorizontal />
        </div>
        <div className="flex items-center gap-1">
          <img src={user} className="w-3 h-3 rounded-full" alt="user" />
          <p className="text-[#9392A2] text-xs font-medium tracking-tight">My male voice • Deep voice</p>
        </div>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-[7px] mt-1">
            <TranslateIcon />
            <p className="text-[#9392A2] text-xs font-medium tracking-tight">Languages</p>
          </div>
          <p className="text-[#0F0C18] text-xs font-medium tracking-tight">English</p>
        </div>
      </div>
    </div>
  );
};

const AllVoicesModal = () => {
  return (
    <>
      <p className="text-[#9392A2] text-sm font-medium leading-snug tracking-tight">Here you can manage all your voice and <br />connect them to languages.</p>
      <SearchBar className="bg-white w-full rounded-full text-xs mt-4" inputCss="bg-white" placeholder="Search voices" />
      <p className="text-[#9392A2] mt-4 text-xs font-medium tracking-tight">My voices</p>
      <div className="px-3 py-2 rounded-xl bg-white cursor-pointer mt-3 mb-2">
        <div className="flex items-center gap-3">
          <div className="flex items-center justify-center w-8 h-8 border border-[#9392A2] border-dashed rounded-full">
            <FaPlus />
          </div>
          <div className="text-[#9392A2] text-sm font-medium tracking-tight">Add your voice</div>
        </div>
      </div>
      <Voice />
      <p className="text-[#9392A2] mt-5 mb-3 text-xs font-medium tracking-tight">System voices</p>
      <Voice />
      <Voice />
      <Voice />
    </>
  );
};

export default AllVoicesModal;